import { Keys, Scene } from "excalibur";
import { goToScene } from "../../main";
import { createGainedItem, sendAlert } from "../../utils";
import { gameState, inventoryState } from "../../state/stateManager";
import { Resources } from "../../Resources";

export default class Treatments extends Scene {
  constructor() {
    super();
    this.activeItem = 0;
    this.menuItems = 3;
  }
  onActivate() {
    this.treatments = document.getElementById("treatments");
    this.treatments.classList.add("activeMenu");
    this.menu = document.getElementById("treatments-menu");
    this.menu.classList.add("activeMenuMenu");
    this.acidPad = document.getElementById("acid-pad");
    this.acidVapor = document.getElementById("acid-vapor");
    this.synthetic = document.getElementById("synthetic-strip");
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      goToScene("onlineMarket");
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Left)) {
      Resources.Click.play();
      if (this.activeItem === 0) {
        this.activeItem = this.menuItems - 1;
      } else {
        this.activeItem = this.activeItem - 1;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Right)) {
      Resources.Click.play();
      if (this.activeItem === this.menuItems - 1) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      console.log("buy; pressed space");
      let coins = gameState.getCoins();
      let inventory = inventoryState.getInventory();
      if (this.activeItem === 0) {
        //buy acidpad $20
        if (coins >= 20) {
          console.log("have enough coins, should buy acidpad");

          let acidPads = inventory.treatments.acidPads;
          if (acidPads == null || acidPads == undefined) {
            acidPads = 0;
          }
          inventory.treatments.acidPads = acidPads + 1;
          gameState.setCoins(coins - 20);
          Resources.Coins.play();
          createGainedItem("Acid Pad");
          inventoryState.setInventory(inventory);
        } else {
          Resources.Error.play();
          sendAlert("You Do Not Have Enough Coins");
        }
      } else if (this.activeItem === 1) {
        //buy acid vapor $5
        if (coins >= 5) {
          console.log("have enough coins, should buy acidvapor");

          let acidVapors = inventory.treatments.acidVapors;
          if (acidVapors == null || acidVapors == undefined) {
            acidVapors = 0;
          }
          inventory.treatments.acidVapors = acidVapors + 1;
          gameState.setCoins(coins - 5);
          Resources.Coins.play();
          createGainedItem("Acid Vapor");
          inventoryState.setInventory(inventory);
        } else {
          Resources.Error.play();
          sendAlert("You Do Not Have Enough Coins");
        }
      } else if (this.activeItem === 2) {
        //buy synthetic $15
        if (coins >= 15) {
          console.log("have enough coins, should buy synthetic");

          let synthetic = inventory.treatments.synthetic;
          if (synthetic == null || synthetic == undefined) {
            synthetic = 0;
          }
          inventory.treatments.synthetic = synthetic + 1;
          gameState.setCoins(coins - 15);
          Resources.Coins.play();
          createGainedItem("Synthetic Strip");
          inventoryState.setInventory(inventory);
        } else {
          Resources.Error.play();
          sendAlert("You Do Not Have Enough Coins");
        }
      }
    }
    this.showCorrect();
  }
  showCorrect() {
    switch (this.activeItem) {
      case 0:
        this.acidPad.classList.add("activeProduct");
        this.acidVapor.classList.remove("activeProduct");
        this.synthetic.classList.remove("activeProduct");
        break;
      case 1:
        this.acidPad.classList.remove("activeProduct");
        this.acidVapor.classList.add("activeProduct");
        this.synthetic.classList.remove("activeProduct");
        break;
      case 2:
        this.acidPad.classList.remove("activeProduct");
        this.acidVapor.classList.remove("activeProduct");
        this.synthetic.classList.add("activeProduct");
        break;
      default:
        break;
    }
  }
  onDeactivate() {
    this.treatments.classList.remove("activeMenu");
    this.menu.classList.remove("activeMenuMenu");
  }
}
